import { css } from "@emotion/react";
import { SmallDivider } from "@minted/fancyclothes";
import React, { memo } from "react";

const dividerStyles = {
  container: (hideLast: boolean) => css`
    text-align: center;

    ${hideLast &&
    css`
      &:last-child {
        display: none;
      }
    `}
  `,
};

export type DisplayDividerSectionProps = {
  hideLast?: boolean;
};
const DisplayDividerSection = ({
  hideLast = false,
}: DisplayDividerSectionProps) => (
  <div css={dividerStyles.container(hideLast)}>
    <SmallDivider />
  </div>
);

const MemoizedDividerSection = memo(DisplayDividerSection);

export { MemoizedDividerSection as DisplayDividerSection };
